import type {Result, UseCase} from 'framework';
import type {AssistantError} from '../../domain/errors';
import type {Conversation} from '../../domain/conversation';
import type {AssistantRepository} from '../ports/assistant.repository';

export class CreateConversation implements UseCase<[], Conversation> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(): Promise<Result<Conversation, AssistantError>> {
    return this.repository.create();
  }
}
